<label class="avano-formlabel"
  >{{ label }}<i *ngIf="required" class="icon-special-required-indicator"></i>
  <i *ngIf="tooltip?.length" class="icon-content-info avano-tooltip-icon" [title]="tooltip"></i>
</label>
<div [class.avano-radio-checkbox-group-horizontal]="alignHorizontal">
  <ng-content></ng-content>
</div>
